(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-content-weeks.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-content-weeks.js'); 
'use strict';

svs.maltipset.views.BetslipContentWeeks = Backbone.Marionette.View.extend({
  ui: {
    weekInputs: '.maltips-betslip-weeks .form-toggle-group input'
  },
  events: {
    'click @ui.weekInputs': 'onWeekChange'
  },
  template: function(data) {
    data.numWeeksSelected = svs.maltipset.collections.coupons.models[0].get(
      'numWeeks'
    );
    return svs.maltipset.templates.betslip_content_weeks(data);
  },

  onWeekChange: function(e) {
    var numWeeks = isNaN(e.target.value) ? 1 : parseInt(e.target.value, 10);
    this.model.get('coupon').updateNumWeeks(numWeeks);
  }
});

 })(window);